<template>
  <mf-card-container data-userflow-id="coupon-discount-date" class="mt-4 date-card" title="Datas">
    <div class="d-flex align-center">
      <h2 class="period-title mb-0 mr-1">Período de validade</h2>
      <mf-tooltip max-width="290" top variant="secondary">
        <template #activator="{ on }">
          <mf-icon dense color="cinza-l10" icon="info" />
        </template>
        Período em que o consumidor conseguirá adicionar um cupom na carteira.
      </mf-tooltip>
    </div>

    <div class="w-50 mt-2">
      <mf-date-range-picker
        icon
        outlined
        :edit-only-end-date="campaign.status === 'ACTIVE'"
        end-date-future
        block-past-date
        :initial-date.sync="campaign.startDate"
        :final-date.sync="campaign.expiresAt"
        :status="campaign.status"
        :error-messages="errorDate"
        :error="
          (validations.campaign.startDate && validations.campaign.startDate.$error) || (validations.campaign.expiresAt && validations.campaign.expiresAt.$error)
        "
        :disabled="isFinished"
      />
    </div>
    <div data-userflow-id="coupon-discount-var-date">
      <mf-toggle v-model="campaign.variableValidity" :disabled="disableFields" class="mf-toggle mb-2" label="Validade variável" hide-details />
      <p>
        Ative a opção para ajustar dinamicamente a validade do cupom de desconto, permitindo que ele expire após um período específico desde sua inclusão na
        carteira.
      </p>
      <div v-if="campaign.variableValidity" class="validate-in-days">
        <mf-number-input
          v-model="campaign.daysToUseBenefitAfterRegistration"
          outlined
          label="Validade em dias"
          :value="campaign.daysToUseBenefitAfterRegistration"
          :min="1"
          show-arrows
          :disabled="disableFields"
          :error="validations.campaign.daysToUseBenefitAfterRegistration && validations.campaign.daysToUseBenefitAfterRegistration.$error"
          :error-messages="errordaysToUseBenefitAfterRegistration"
        />
      </div>
    </div>
  </mf-card-container>
</template>

<script>
export default {
  name: 'CouponDiscountDate',
  components: {},
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    validations: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isFinished() {
      return this.campaign.status === 'FINISHED'
    },
    disableFields() {
      return ['FINISHED', 'ACTIVE'].includes(this.campaign.status)
    },
    errorDate() {
      if (!this.validations.campaign || !this.validations.campaign.startDate) return ''
      if (this.validations.campaign.startDate.$error) {
        if (!this.validations.campaign.startDate.required) return 'Selecione uma data de envio.'
        else if (this.campaign.status !== 'ACTIVE' && !this.validations.campaign.startDate?.isFuture) return 'A data de envio deve ser no futuro.'
        else if (!this.validations.campaign.startDate?.isBeforeEndDate) return 'Período inválido.'
      }
      if (!this.validations.campaign || !this.validations.campaign.expiresAt) return ''
      if (this.validations.campaign.expiresAt.$error) return 'Período inválido'
      return ''
    },
    errordaysToUseBenefitAfterRegistration() {
      if (!this.validations.campaign.daysToUseBenefitAfterRegistration) return ''
      if (this.validations.campaign.daysToUseBenefitAfterRegistration.$error) return 'Informe a validade em dias.'
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.date-card {
  .period-title {
    font-weight: 600;
    color: $cinza-d10;
    font-size: 16px;
  }
}

.w-50 {
  max-width: 50%;
}

.mf-toggle {
  ::v-deep label {
    color: $cinza-d10 !important;
    font-weight: 600 !important;
    font-size: 16px !important;
  }
}

p {
  color: $cinza-0;
  font-size: 14px;
  line-height: 20px;
  max-width: 480px;
}

.validate-in-days {
  max-width: 170px;
}
</style>
